import React, { useState, useEffect } from 'react';
import './LoadingBar.scss';
import { observer } from 'mobx-react';

interface ILoadingBarProps {
    jobExecuting: boolean;
    progress: number;
    processOccurring: string;
}

export const LoadingBar = observer((props: ILoadingBarProps) => {
    const { jobExecuting, progress, processOccurring } = props;
    const [displayProgress, setDisplayProgress] = useState(0);

    useEffect(() => {
        if (jobExecuting) {
            if (progress > displayProgress) {
                const interval = setInterval(() => {
                    setDisplayProgress(prev => {
                        if (prev >= progress) {
                            clearInterval(interval);
                            return progress;
                        }
                        return prev + 1;
                    });
                }, 20); // Adjust this value to change the speed of the progress update
                return () => clearInterval(interval);
            }
        } else {
            setDisplayProgress(0);
        }
    }, [jobExecuting, progress]);
    
    return (
        <div role="status" className="loading-bar-container">
            {displayProgress > 0 ? <div className="loading-bar-background">
                <div className="loading-bar-fill" style={{ width: `${displayProgress}%` }} />
            </div> : null}
            <div className={displayProgress > 0 ? "text-container" : ''}>
                <h2 className="loading-text h4">{processOccurring}</h2>
                {displayProgress > 0 ? <h2 className="loading-bar-text h4">{Math.round(displayProgress)}%</h2> : null}
            </div>
        </div>
    );
});